import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Noble Mick's - Craft Beverage Company's
// "Espresso Martini Frozen Cocktail-Just add Water + Vodka" (p_x4sg3kehm6),
// pulled from Faire's live `GET /api/product-reviews/product/{product_token}`
// endpoint (the same data source that powers the product's own PDP review
// list) — verbatim comment, real reviewer, real rating, real publish date.
export const review_nm4: FaireReviewEntity = {
  token: "review_nm4",
  type: "review",
  brandName: "Noble Mick's - Craft Beverage Company",
  brandToken: "b_kxk5df5zt5",
  productToken: "p_x4sg3kehm6",
  reviewType: "product",
  reviewerName: "Warren C.",
  reviewerLocation: "Easton, PA, United States",
  stars: 5,
  reviewText: "Our best-selling flavor by far.",
  reviewDate: "Sep 5, 2025",
  meta: {
    source: "api" as const,
    importedAt: "2026-08-11T21:06:39.000Z",
    importedBy: "entity-db-cli",
  },
};
